module.exports = __webpack_public_path__ + "img/password-change-success.36ac8529.svg";